import imagePath from "../assets/img/shjr/login.png"

export default{
    login: {
        imagePath,
        desc: "金融舆情管理服务平台"
    },
    navBarTitle: "金融舆情管理服务平台",
    email:"carolchen@vip.qq.com",
    reportTip: "温馨提示：本报告的数据来自上海⾦融与发展实验室⾦融舆情管理服务平台，若对报告内容有任何问题，可与客服（carolchen@vip.qq.com）联系，谢谢！"
}